module.exports = __webpack_public_path__ + "static/media/kalle.219fe968.JPG";